<script lang="ts" setup>
	import {useFilters} from '@/store/filter.store';
	import {storeToRefs} from 'pinia';

	const emit = defineEmits(['surplus-updated']);

	const filterStore = useFilters();

	const {surplusFilter} = storeToRefs(filterStore);

	const toggleSurplus = () => {
		filterStore.setSurplus(!surplusFilter.value);
		emit('surplus-updated');
	};
</script>

<template>
	<div class="filter-part surplus-filter">
		<h3 class="filter-part__title">
			{{ $t('site.products.overview.filters.surplus.title') }}
		</h3>
		<div>
			<ul class="filter-checklist">
				<li id="filter-checkbox-item_surplus" class="filter-checkbox-item">
					<label class="filter-checkbox-label">
						<input :checked="surplusFilter"
						       name="surplus"
						       type="checkbox"
						       @change="toggleSurplus" />
						<span class="filter-checkbox-icon" />
						<span class="filter-checkbox-text">
							{{ $t('site.products.overview.filters.surplus.showonly') }}
					    </span>
					</label>
				</li>
			</ul>
		</div>
	</div>
</template>
